export const OFFER_CATEGORY_VALUE = "offer";
export const REFERENCE_CATEGORY = "reference";
export const NOT_APPLICABLE = "N/A";
export const OFFER = "Offer";
export const ROLE = "Role";
export const REFERENCE = "Reference";
export const MESSAGE_TEMPLATE_CATEGORIES = [
  {
    label: "Offer",
    value: OFFER_CATEGORY_VALUE
  },
  {
    label: "Reference",
    value: "reference"
  }
];
export const PROFESSIONAL_REFERENCE_TYPE_NAME = "Professional Reference";
